import "./index.scss";

import React, { useEffect, useState } from "react";
import { useAppStore } from "../../stores";
import type { AppData } from "../../types/app-data.d";

import HeaderBottom from "./bottom";
import HeaderTop from "./top";

export default function Component() {
	const appStore = useAppStore((state) => state);

	const [navMenuList, setNavMenuList] = useState<AppData["navMenuList"]["hits"] | null>(null);

	useEffect(() => {
		if (appStore.navMenuList?.hits.length > 0) {
			const hits = appStore.navMenuList.hits;

			const headerItems = hits.filter((item) => item.data.groups === "header");

			const dropdownItems = hits.filter((item) => item.data.parent);

			const map = new Map();
			headerItems.forEach((item) => {
				map.set(item._id, { ...item, children: [] });
			});

			dropdownItems.forEach((child) => {
				const parentId = child.data.parent;
				if (map.has(parentId)) {
					map.get(parentId).children.push(child);
				} else {
					console.warn(`⚠️ Родитель не найден для`, child.displayName, parentId);
				}
			});

			const structured = Array.from(map.values());
			setNavMenuList(structured);
		}
	}, [appStore.navMenuList]);

	return (
		<header className="header">
			<HeaderTop navMenuList={navMenuList} />
			<HeaderBottom navMenuList={navMenuList} />
		</header>
	);
}
